import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { UserService } from 'src/app/modules/services/user.service';
import { errorDescription, url } from 'src/app/modules/util/constants';

@Component({
  selector: 'app-edit-password',
  templateUrl: './edit-password.component.html',
  styleUrls: ['./edit-password.component.css']
})
export class EditPasswordComponent {

  constructor(private router: Router, private fb: FormBuilder, private userService: UserService, private messageService: MessageService) {
    this.passwordForm = this.fb.group({
      password: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(20)]],
      passwordConfirm: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(20)]]
    }, { validators: passwordMatchingValidator });
  }

  @Input() displayDialog: boolean = false;
  @Output() displayDialogChange = new EventEmitter<boolean>();
  @Input() userName: string = '';
  passwordForm: FormGroup;

  changePassword() {
    this.userService.changePassword(this.userName, this.passwordForm.value['password']).subscribe({
      next: response => {
        if (response.status === 'success') {
          this.messageService.add({detail: 'Cambio de contraseña correcto', severity: 'success'});
          this.closeDialog();
        } else {
          this.messageService.add({detail: 'No fue posible cambiar la contraseña', severity: 'error'});
        }
      },
      error: error => {
        this.messageService.add({severity: 'error', detail: errorDescription[error.error.error]});
        this.router.navigate([url['login']]);
      }
    });
  }

  closeDialog() {
    this.displayDialog = false;
    this.passwordForm.markAsPristine();
    this.passwordForm.get('password')?.patchValue('');
    this.passwordForm.get('passwordConfirm')?.patchValue('');
    this.displayDialogChange.emit(this.displayDialog);
  }
}

export const passwordMatchingValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const password = control.get('password');
  const passwordConfirm = control.get('passwordConfirm');
  return password && passwordConfirm && password.value.length > 5 && passwordConfirm.value.length > 5 && password.value !== passwordConfirm.value
    ? { passwordNotMatching: true }
    : null;
};